// "More collections" shelf slider. Arrows step two cards at a time with a
// manual rAF animation because Chromium ignores programmatic smooth scrolling
// on scroll-snap containers; snap is released while animating and re-engaged
// on the boundary. Touch swiping uses the native snap directly.
class LettoriaCollectionSlider extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('[ref-track]');
    if (!this.track) return;
    const prev = this.querySelector('[ref-prev]');
    const next = this.querySelector('[ref-next]');
    if (prev) prev.addEventListener('click', () => this.step(-1));
    if (next) next.addEventListener('click', () => this.step(1));
  }

  step(dir) {
    const track = this.track;
    const card = track.querySelector('[ref-card]');
    if (!card) return;
    const gap = parseFloat(getComputedStyle(track).columnGap) || 18;
    const step = (card.getBoundingClientRect().width + gap) * 2;
    const from = track.scrollLeft;
    const to = Math.max(0, Math.min(from + dir * step, track.scrollWidth - track.clientWidth));

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      track.scrollLeft = to;
      return;
    }

    const start = performance.now();
    const DURATION = 380;
    track.style.scrollSnapType = 'none';
    cancelAnimationFrame(this.raf);
    const frame = (now) => {
      let p = Math.min(1, (now - start) / DURATION);
      p = 1 - Math.pow(1 - p, 3); // ease-out cubic
      track.scrollLeft = from + (to - from) * p;
      if (p < 1) {
        this.raf = requestAnimationFrame(frame);
      } else {
        track.style.scrollSnapType = '';
      }
    };
    this.raf = requestAnimationFrame(frame);
  }
}

if (!customElements.get('lettoria-collection-slider')) {
  customElements.define('lettoria-collection-slider', LettoriaCollectionSlider);
}
